import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { lastValueFrom, Observable } from 'rxjs';
import { map, startWith, take, tap } from 'rxjs/operators';
import { MapToGA4 } from 'src/business/Mapper/map-to-ga4-item';
import { CheckoutConfiguration, MenuConfiguration } from 'src/business/models/main-configuration.model';
import { LANGUAGE } from 'src/core-lib/misselaineous/boot.tokens';
import { PageBase } from 'src/core-lib/navigation/base-page';
import { ComponentPage } from 'src/core-lib/navigation/models/component-page.model';
import { Page } from 'src/core-lib/navigation/models/page.interface';
import { UmbracoImage } from 'src/core-lib/umbraco/umbraco-image.model';
import { GA4 } from 'src/externals/tag-manager/models/ga4.model';
import { StepComponent } from 'src/layout/step/step.component';
import { ContentCacheUtils } from 'src/utils/storage.util';
import { CheckoutPageModule } from '../../checkout-page.module';
import { BasketService } from '../../services/basket.service';



interface BasketPage extends Page {
    store_image: UmbracoImage;
    contact_image: UmbracoImage;
    cards: Array<UmbracoImage>;
}

@Component({
    selector: 'app-basket-page',
    standalone: true,
    imports: [
        CommonModule,
        CheckoutPageModule,
        StepComponent,
    ],
    templateUrl: './basket-page.component.html',
    styleUrls: ['./basket-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BasketPageComponent extends PageBase implements ComponentPage, OnInit {
    page: BasketPage;
    menu: Partial<MenuConfiguration>;

    checkout: Partial<CheckoutConfiguration>;
    basketQuantity$: Observable<boolean>;


    constructor(
        private basketService: BasketService,

        private router: Router,
        route: ActivatedRoute,
        @Inject(LANGUAGE)
        public language: string
    ) {
        super(route);
        this.basketQuantity$ = this.basketService.basket$.pipe(startWith(null), map(b => (b?.quantity ?? 0) == 0))
    }
    async ngOnInit() {
        this.menu = ContentCacheUtils.menu<MenuConfiguration>();
        this.checkout = ContentCacheUtils.checkout<CheckoutConfiguration>();
        let basket = await lastValueFrom(this.basketService.basket$.pipe(take(1)));
        queueMicrotask(() =>
            GA4.track(MapToGA4.viewCart(basket))
        )
    }


}
